import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ShipOrderSku } from 'src/app/models/fbmOrders.model';

@Component({
  selector: 'app-fbm-skudetails',
  templateUrl: './fbm-skudetails.component.html',
  styleUrls: ['./fbm-skudetails.component.scss']
})
export class FbmSkudetailsComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  constructor() { }

  ngOnInit(): void {
  }

  private _skus: Array<ShipOrderSku>;
  @Input() get skuList(): Array<ShipOrderSku> {
    return this._skus;
  }

  set skuList(value) {
    this._skus = value;
    if (value && value?.length > 0) {
      value.forEach((sku: ShipOrderSku) => {
        let index = this._skus.findIndex((f: ShipOrderSku) => f.sku === sku.sku);
        this.skuList[index].imageUrl = sku.image;
      });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
